import type { FunctionComponent } from 'react';
import { useSchoolPageBySlugQuery } from '../../../../graphql/useSchoolPageBySlugQuery';
import { SchoolPageTabs } from './SchoolPageTabs';

export const SchoolPageTabsWithData: FunctionComponent = () => {
  const { data } = useSchoolPageBySlugQuery();
  const tabs = data?.schoolPageBySlug?.tabs;
  if (!tabs?.length) return null;

  return <SchoolPageTabs tabs={tabs} />;
};
